import { useEffect } from 'react';

export default function PageTitle({ title }) {
  useEffect(() => {
    document.title = title ? `${title} | MyTaxNiti` : 'MyTaxNiti';
    return () => { document.title = 'MyTaxNiti'; };
  }, [title]);
  return null;
}